class ShippingProtection extends HTMLElement {
  constructor() {
    super();
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.shippingProtectionRemove = this.querySelector('.shipping-protection__remove');
    this.shippingProtectionId = window.theme.settings.shipping_protection_product_data?.id;
  }

  connectedCallback() {
    if (this.shippingProtectionRemove) {
      this.shippingProtectionRemove.addEventListener("click", this.removeShippingProtection.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.shippingProtectionRemove) {
      this.shippingProtectionRemove.removeEventListener("click", this.removeShippingProtection.bind(this));
    }
  }

  removeShippingProtection(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.shippingProtectionId) return;

    const sections = this.cart
      .getSectionsToRender()
      .map((section) => section.section);
    const sectionUrl = window.location.pathname;

    setCookie('shipping_protection', 'removed', 7);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: `${this.shippingProtectionId}`,
        quantity: 0,
        sections: sections,
        sections_url: sectionUrl,
      }),
    })
      .then((response) => response.json()
      )
      .then((data) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-drawer',
          cartData: data,
        });
        updateFreeShipping();
      });
  }
}

customElements.define("shipping-protection", ShippingProtection);